import { useNavigate } from 'react-router-dom';
import { Box, Button, Grid, Typography } from '@mui/material';

const InvoiceReconcilerPrompt = ({ onContinue, plan }) => {
    const navigate = useNavigate();

    return (
        <Grid item xs={12} container spacing={2} sx={{ p: 4 }}>
            <Grid item xs={12} textAlign="center">
                <Typography variant="h5" sx={{ mb: 3 }}>
                    Would you like to add the {plan} plan?
                </Typography>
                <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
                    Track every payout. Never miss a payment again.
                </Typography>
                <Box display="flex" justifyContent="center" gap={3} mt={4}>
                    <Button
                        variant="outlined"
                        color="primary"
                        onClick={onContinue}
                        sx={{ minWidth: '140px', py: 1.5 }}
                    >
                        No, continue
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => navigate('/subscription-part-two')}
                        sx={{ minWidth: '140px', py: 1.5 }}
                    >
                        Yes, show plans
                    </Button>
                </Box>
            </Grid>
        </Grid>
    );
};

export default InvoiceReconcilerPrompt;
